import { useMemo } from 'react'
import { useSessionUID } from 'src/session/useSession'
import { useAdvancedOverviewState } from '../../api/AdvancedOverviewProvider'
import { isActiveCareTeamMember } from '../careTeam/activeMember'

// The signed-in provider's active roles on this patient, `undefined` until the care team has loaded.
export const useMyCareTeamRoles = (): string[] | undefined => {
  const overview = useAdvancedOverviewState()
  const providerUid = useSessionUID()

  return useMemo(
    () =>
      overview.status === 'ready'
        ? [
            ...new Set(
              overview.overview.careTeam
                .filter((member) => member.providerUid === providerUid && isActiveCareTeamMember(member))
                .map((member) => member.role)
            ),
          ]
        : undefined,
    [overview, providerUid]
  )
}
